import { Component, Input, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
// import { SearchPage } from '../../pages/search/search';
import { Platform, AlertController, PopoverController, IonicModule, IonFooter, IonHeader, IonTitle, IonToolbar } from '@ionic/angular';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';
import { TranslateService } from '@ngx-translate/core';
import { UserDataProvider } from '../../providers/user-data/user-data';
import { LocationServiceProvider } from '../../providers/location-service/location-service';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { Storage } from '@ionic/storage-angular';
import { Venue, RequestUser, SearchVenueRequest } from '../../models/models';
import { VenueSelectionPopoverPage } from '../../pages/venue-selection-popover/venue-selection-popover';
import { AppEventService } from '../../app/app-events';
import { IsActiveMatchOptions, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SearchPage_PATH } from '../../app/app-constants';

/**
 * Generated class for the NavBarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'nav-bar',
  templateUrl: 'nav-bar.html',
  styleUrls: ['./nav-bar.scss'],
  standalone: false,
  imports: [
    CommonModule, IonFooter, IonHeader, IonTitle, IonToolbar
  ]
})
export class NavBarComponent implements OnInit, OnDestroy {
  // Give this instance a random ID
  public instanceId = Math.floor(Math.random() * 1000);

  public searchPage = null; // SearchPage;
  public shouldHideBack: boolean;

  @Input()
  showLogoOnly: boolean = false;

  nearbyList: Array<any>;
  private selectedVenue: Venue;

  // Necessary for searchVenueRequest
  private rowCount: Number = 4;
  private pageNumber: Number = 1;
  private distance: Number = 10000 * 4;

  public showTextSearchBar = false;

  private showTextSearchBarSubscription: any;

  constructor(
    private router: Router,
    private plt: Platform,
    private events: AppEventService,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private userData: UserDataProvider,
    private locationService: LocationServiceProvider,
    private beerService: BeerServiceProvider,
    public popoverCtrl: PopoverController,
    private storage: Storage,
    private cdr: ChangeDetectorRef
  ) {
    this.shouldHideBack = true;
    /*if (this.plt.is("ios")) {
      console.log("iOS, showing back button");
      this.shouldHideBack = false;
    }
    else {
      console.log("android or web, hiding back button");
      this.shouldHideBack = true;
    }*/
  }

  isAndroid(): boolean {
    //return this.plt.is('android');
    return true;
  }

  isSearchPage() {
    
    // Define the options dictionary: we explicitly want exact matching
        const options: IsActiveMatchOptions = {
            fragment: "ignored",
            matrixParams: "ignored",
            queryParams: "ignored",
            paths: "subset"
        };
    return this.router.isActive(SearchPage_PATH, options);
  }

  showSearch() {
    if (!this.isSearchPage()) {
      console.log("nav-bar - showSearch - searchPage NOT active")
      this.router.navigate([ SearchPage_PATH ]).then(() => {
        this.events.publish("navbar:searchpressed");
      });
    }
    else {
      console.log("nav-bar - showSearch - active searchPage")
      //broadcast an event, so the list of beers is reset, in this case the search params become visible again
      this.events.publish("navbar:searchpressed");
      console.log("Root is already set to SearchPage controller, doing nothing, only resetting the list of foundbeers");
    }
  }

  ngOnInit() {
    this.userData.init().then(() => {
      this.storage.get('selected-venue').then((venue) => {
        this.nearbyList = []
        // First read the selected venue from storage
        this.selectedVenue = JSON.parse(venue);
        if (this.selectedVenue != null) {
          this.nearbyList.push(this.selectedVenue);
          console.log('venue-filter-button - saved venue was: ', this.selectedVenue.id);
        }

        // then request the nearest venues (to avoid duplicate selectedVenue in List)
        this.userData.getUserID()
          .then((userID) => {
            let user = new RequestUser(userID, this.locationService.latitude, this.locationService.longitude);
            this.searchNearbyVenues(user, this.rowCount, this.pageNumber, this.distance);
          });
      });

      this.events.subscribe("venue:selected", (venue: Venue) => {
        //console.log("[beer-analysis][beer in wishlist] " + beerInWishlist);
        console.log("venue-filter-button - venue selected with id: " + JSON.stringify(venue));
        this.selectedVenue = venue;
        this.cdr.detectChanges();
      });

      this.events.subscribe("venue:deselected", () => {
        //console.log("[beer-analysis][beer in wishlist] " + beerInWishlist);
        console.log("venue-filter-button - venue deselected");
        this.selectedVenue = null;

        this.cdr.detectChanges();
      });

      this.showTextSearchBarSubscription = (value) => {
        console.log("this.showTextSearchBar = " + value + ", instance = " + this.instanceId);
        this.showTextSearchBar = value;
        this.cdr.detectChanges();
      }
      this.events.subscribe("show:textsearchbar", this.showTextSearchBarSubscription);
    });
  }
  ngOnDestroy() {
      this.events.unsubscribe("venue:selected");
      this.events.unsubscribe("venue:deselected");
      this.events.unsubscribe("venue:deselected");
  }

  searchNearbyVenues(user: RequestUser, rowCount: Number, pageNumber: Number, distance: Number) {
    // Request nearby beerhive venues TODO subcribe implementation...
    let searchVenueRequest = new SearchVenueRequest(user.userid, user.latitude, user.longitude, rowCount, pageNumber, distance);
    this.beerService.requestNearbyBeerhiveVenues(searchVenueRequest).subscribe(
      (resp: any) => {
        console.log("venue-filter-button - server responsed 200!")
        resp.forEach(element => {
          if (this.selectedVenue == null || element.id != this.selectedVenue.id) {
            this.nearbyList.push(element);
          }
        });

        // sort according to better distance estimation
        this.nearbyList.sort(function (a, b) {
          return a.distance - b.distance;
        })

      }, err => console.log(err));
  }

  presentPopover(myEvent) {
    console.log("venue-filter-button - presenting popover!")
    let popoverProm = this.popoverCtrl.create({
      component: VenueSelectionPopoverPage,
      componentProps: {venues: this.nearbyList, selectedVenue: this.selectedVenue},
      event: myEvent,
      cssClass: 'venue-filter-popover'
    });
    popoverProm.then((popover) => popover.present());
  }
}
